<div class="step-main-wrapper">
  <div class="container">
    <h1>{{ "create-assignment.from-category" | translate }}</h1>

    <div class="box-main">
      <div class="grid">
        <div
          class="card blue-hover"
          *ngFor="let category of categories$ | async; trackBy: trackByCategoryId"
          [ngClass]="{ selected: category.id === selectedCategoryId }"
          (click)="onCreateFromCategory(category.id)"
        >
          <i class="bi bi-calendar-event-fill icon blue"></i>

          <div class="icon-list">
            <i>
              <img [src]="category?.imagePath" [alt]="category?.name" loading="lazy"/>
            </i>
            <h2>{{ category.name }}</h2>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
